module.exports = __webpack_public_path__ + "img/grid_layout_1_3.0f0b72dd.svg";